import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';

/**
 * Hook to reconcile texting contacts for an account.
 * This updates conversation names when contact information has changed.
 *
 * Uses the endpoint: POST /impersonate/:impAccountId/conversation/reconcileContacts
 */
export const useReconcileTextingContacts = ({
	onError,
	onSuccess,
	userSession,
}: {
	onSuccess?: () => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
	userSession: Api.UserSessionContext;
}) => {
	return useMutation({
		mutationFn: ({ accountId }: { accountId: string }) => {
			return new Promise((resolve, reject) => {
				userSession.webServiceHelper
					.callWebServiceRawResponse(
						`impersonate/${accountId}/conversation/reconcileContacts`,
						'POST',
						null,
						resolve,
						reject
					)
					.catch(reject);
			});
		},
		onError,
		onSuccess,
	});
};
